//@flow

import React from 'react';

import Cheese from '../../../../assets/images/pages/pizza/fields/pizza_cheese@3x.png';

export default class PizzaCheese extends React.PureComponent<{}> {
  render() {
    return (
      <div {...this.props} className="pizza-image pizza-cheese">
        <img src={Cheese} />
      </div>
    );
  }
}
